import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genSummaryStyle = function genSummaryStyle(token) {
  var componentCls = token.componentCls,
    lineWidth = token.lineWidth,
    tableBorderColor = token.tableBorderColor,
    calc = token.calc;
  var tableBorder = "".concat(unit(lineWidth), " ").concat(token.lineType, " ").concat(tableBorderColor);
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty(_defineProperty({}, "".concat(componentCls, "-summary"), {
    position: 'relative',
    zIndex: token.zIndexTableFixed,
    background: token.tableBg,
    '> tr': {
      '> th, > td': {
        borderBottom: tableBorder
      }
    }
  }), "div".concat(componentCls, "-summary"), {
    boxShadow: "0 ".concat(unit(calc(lineWidth).mul(-1).equal()), " 0 ").concat(tableBorderColor)
  }));
};
export default genSummaryStyle;